import { render } from "./UserPage.vue?vue&type=template&id=32cf56d8"
import script from "./UserPage.ts?vue&type=script&lang=js"
export * from "./UserPage.ts?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__